export const AUTOSPECS_URL =
  'https://help.autodesk.com/view/AUTOSPECS/ENU/?guid=Trials_And_Subscriptions_FAQs';
